"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datasetRunsTableUiColumnDefinitions = void 0;
exports.datasetRunsTableUiColumnDefinitions = [
    {
        uiTableName: "Dataset Run ID",
        uiTableId: "id",
        clickhouseTableName: "dataset_run_items_rmt",
        clickhouseSelect: "drm.dataset_run_id",
    },
    {
        uiTableName: "Created At",
        uiTableId: "createdAt",
        clickhouseTableName: "dataset_run_items_rmt",
        clickhouseSelect: "drm.dataset_run_created_at",
    },
    {
        uiTableName: "Scores (numeric)",
        uiTableId: "agg_scores_avg",
        clickhouseTableName: "dataset_run_items_rmt",
        clickhouseSelect: "sa.scores_avg",
    },
    {
        uiTableName: "Scores (categorical)",
        uiTableId: "agg_score_categories",
        clickhouseTableName: "dataset_run_items_rmt",
        clickhouseSelect: "sa.score_categories",
    },
    {
        uiTableName: "Scores (boolean)",
        uiTableId: "agg_score_booleans",
        clickhouseTableName: "dataset_run_items_rmt",
        clickhouseSelect: "sa.score_booleans",
    },
];
